// extracted by mini-css-extract-plugin
module.exports = {"dragLabelContainer":"styles_dragLabelContainer__3lAAq","dragLabel":"styles_dragLabel__1AW0m","dragging":"styles_dragging__1gl7U"};